import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';

export default function AuthScreen() {
  const [mode, setMode] = useState('login'); // 'login' | 'register' | 'reset'
  const { login, register } = useAuth();
  const [form, setForm] = useState({ email: '', password: '', name: '', phone: '', zone: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setSuccess(''); setLoading(true);
    try {
      if (mode === 'login') {
        await login(form.email, form.password);
      } else if (mode === 'register') {
        if (!form.name.trim()) { setError('El nombre es requerido.'); setLoading(false); return; }
        await register(form);
        setSuccess('¡Registro exitoso! Tu cuenta está pendiente de aprobación.');
        setMode('login');
      } else if (mode === 'reset') {
        await sendPasswordResetEmail(auth, form.email);
        setSuccess(`Se envió un email a ${form.email} con el enlace para restablecer la contraseña. Revisá también la carpeta de spam.`);
        setMode('login');
      }
    } catch (err) {
      const msgs = {
        'auth/user-not-found': 'No existe una cuenta con ese email.',
        'auth/wrong-password': 'Contraseña incorrecta.',
        'auth/email-already-in-use': 'El email ya está en uso.',
        'auth/weak-password': 'La contraseña debe tener al menos 6 caracteres.',
        'auth/invalid-email': 'Email inválido.',
        'auth/invalid-credential': 'Credenciales incorrectas.',
        'auth/too-many-requests': 'Demasiados intentos. Esperá unos minutos.',
      };
      setError(msgs[err.code] || err.message);
    }
    setLoading(false);
  }

  const titles = {
    login: 'Acceder al sistema',
    register: 'Crear cuenta de embajadora',
    reset: 'Restablecer contraseña',
  };

  return (
    <div className="auth-screen">
      <div className="auth-box">
        <div className="auth-logo">FLORESIENDO</div>
        <div className="auth-subtitle-brand">aromas · hogar · bienestar</div>
        <div className="auth-title">{titles[mode]}</div>

        {error && <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>}
        {success && <div className="success-msg" style={{ marginBottom: 12 }}>{success}</div>}

        <form className="auth-form" onSubmit={handleSubmit}>
          {mode === 'register' && (
            <>
              <div className="field-group">
                <label>Nombre completo</label>
                <input value={form.name} onChange={e => set('name', e.target.value)} required placeholder="Tu nombre" />
              </div>
              <div className="field-group">
                <label>Teléfono</label>
                <input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="Opcional" />
              </div>
              <div className="field-group">
                <label>Zona / Ciudad</label>
                <input value={form.zone} onChange={e => set('zone', e.target.value)} placeholder="Ej: Córdoba Centro" />
              </div>
            </>
          )}

          <div className="field-group">
            <label>Email</label>
            <input
              type="email" value={form.email}
              onChange={e => set('email', e.target.value)}
              required placeholder="tu@email.com"
              autoComplete="email"
            />
          </div>

          {mode !== 'reset' && (
            <div className="field-group">
              <label>Contraseña</label>
              <input
                type="password" value={form.password}
                onChange={e => set('password', e.target.value)}
                required placeholder="••••••"
                autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              />
            </div>
          )}

          {mode === 'reset' && (
            <p style={{ fontSize: 12, color: 'var(--text-light)', marginTop: -4 }}>
              Te enviaremos un email con un enlace para crear una nueva contraseña.
            </p>
          )}

          <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: 8 }}>
            {loading ? '...' : mode === 'login' ? 'Ingresar' : mode === 'register' ? 'Registrarme' : 'Enviar email de recuperación'}
          </button>
        </form>

        {/* Links de navegación */}
        <div className="auth-toggle" style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 16 }}>
          {mode === 'login' && (
            <>
              <span>
                ¿Olvidaste tu contraseña?{' '}
                <button onClick={() => { setMode('reset'); setError(''); setSuccess(''); }}>
                  Recuperar acceso
                </button>
              </span>
              <span>
                ¿No tenés cuenta?{' '}
                <button onClick={() => { setMode('register'); setError(''); setSuccess(''); }}>
                  Registrarme
                </button>
              </span>
            </>
          )}
          {mode === 'register' && (
            <span>
              ¿Ya tenés cuenta?{' '}
              <button onClick={() => { setMode('login'); setError(''); setSuccess(''); }}>Ingresar</button>
            </span>
          )}
          {mode === 'reset' && (
            <span>
              <button onClick={() => { setMode('login'); setError(''); setSuccess(''); }}>← Volver al login</button>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}